"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./adv-manage.component.scss.ngstyle");
var i1 = require("@angular/core");
var i2 = require("../adv-edit/adv-edit.component.ngfactory");
var i3 = require("../adv-edit/adv-edit.component");
var i4 = require("../../Services/captcha.service");
var i5 = require("@angular/common/http");
var i6 = require("@angular/forms");
var i7 = require("../../Services/service.service");
var i8 = require("@angular/router");
var i9 = require("../../Services/subscribtion.service");
var i10 = require("../../Services/geolocation.service");
var i11 = require("../../Services/previousroute.service");
var i12 = require("./adv-manage.component");
var styles_AdvManageComponent = [i0.styles];
var RenderType_AdvManageComponent = i1.ɵcrt({ encapsulation: 2, styles: styles_AdvManageComponent, data: {} });
exports.RenderType_AdvManageComponent = RenderType_AdvManageComponent;
function View_AdvManageComponent_0(_l) { return i1.ɵvid(0, [i1.ɵqud(402653184, 1, { advEdit: 0 }), (_l()(), i1.ɵeld(1, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), i1.ɵeld(2, 0, null, null, 1, "app-adv-edit", [], null, null, null, i2.View_AdvEditComponent_0, i2.RenderType_AdvEditComponent)), i1.ɵdid(3, 114688, [[1, 4], ["advEditComponent", 4]], 0, i3.AdvEditComponent, [i4.CaptchaService, i5.HttpClient, i6.FormBuilder, i7.MainService, i8.ActivatedRoute, i9.SubscribtionService, i10.GeolocationService, i11.PreviousRouteService, i8.Router], null, null)], function (_ck, _v) { _ck(_v, 3, 0); }, null); }
exports.View_AdvManageComponent_0 = View_AdvManageComponent_0;
function View_AdvManageComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-adv-manage", [], null, null, null, View_AdvManageComponent_0, RenderType_AdvManageComponent)), i1.ɵdid(1, 4308992, null, 0, i12.AdvManageComponent, [i4.CaptchaService, i5.HttpClient, i6.FormBuilder, i7.MainService, i8.ActivatedRoute], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_AdvManageComponent_Host_0 = View_AdvManageComponent_Host_0;
var AdvManageComponentNgFactory = i1.ɵccf("app-adv-manage", i12.AdvManageComponent, View_AdvManageComponent_Host_0, {}, {}, []);
exports.AdvManageComponentNgFactory = AdvManageComponentNgFactory;
